import React, { useState } from 'react';
import { Facebook, Twitter, Instagram, Linkedin, Mail, Phone, X } from 'lucide-react';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer id="footer" className="bg-[#0A5E5C] text-white pt-20 pb-10" data-id="element-156">
        <div className="container mx-auto px-4" data-id="element-157">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-158">
            {/* Brand Column */}
            <div className="lg:col-span-1" data-id="element-159">
              <div className="flex items-center gap-2 mb-6" data-id="element-160">
                <div className="w-8 h-8 bg-white/10 rounded-full flex items-center justify-center" data-id="element-161">
                  <span className="text-[#D4A843] font-serif font-bold text-lg" data-id="element-162">
                    FG
                  </span>
                </div>
                <span className="text-xl font-serif font-bold" data-id="element-163">
                  Fair Gaming Space
                </span>
              </div>
              <p className="text-white/70 text-sm leading-relaxed mb-6" data-id="element-164">
                We protect players' rights and promote the development of a fair
                gambling market in Ukraine. Join our community.
              </p>
              <div className="flex gap-4" data-id="element-165">
                <a href="https://www.facebook.com/share/14bkTnc99Km/?mibextid=wwXIfr" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#D4A843] transition-colors" data-id="element-166">
                  <Facebook size={18} data-id="element-167" />
                </a>
                <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#D4A843] transition-colors" data-id="element-168">
                  <Twitter size={18} data-id="element-169" />
                </a>
                <a href="https://www.instagram.com/olenavodolazhko?igsh=bHJjNTRjcWwzb2dl" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#D4A843] transition-colors" data-id="element-170">
                  <Instagram size={18} data-id="element-171" />
                </a>
                <a href="https://www.linkedin.com/in/olena-vodolazhko-372ab576?utm_source=share_via&utm_content=profile&utm_medium=member_ios" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#D4A843] transition-colors" data-id="element-172">
                  <Linkedin size={18} data-id="element-173" />
                </a>
                <a href="https://t.me/prostirchesnoigry" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#D4A843] transition-colors" data-id="element-174">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" data-id="element-175">
                    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.479.33-.913.492-1.302.48-.428-.012-1.252-.242-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" data-id="element-176" />
                  </svg>
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div data-id="element-177">
              <h3 className="text-lg font-serif font-bold mb-6 text-[#D4A843]" data-id="element-178">
                Quick Links
              </h3>
              <ul className="space-y-3" data-id="element-179">
                {[{
                name: 'Home',
                target: 'hero'
              }, {
                name: 'Self-Help',
                target: 'self-help'
              }, {
                name: 'Tests',
                target: 'pgsi-test'
              }, {
                name: 'Signs',
                target: 'gambling-signs'
              }, {
                name: 'Helping Loved Ones',
                target: 'dopomoga-blyzkij-lyudyni'
              }].map(item => <li key={item.name} data-id="element-180">
                    <button onClick={() => {
                  const el = document.getElementById(item.target);
                  if (el) {
                    const headerOffset = 80;
                    const elementPosition = el.getBoundingClientRect().top + window.scrollY;
                    window.scrollTo({
                      top: elementPosition - headerOffset,
                      behavior: 'smooth'
                    });
                  }
                }} className="text-white/70 hover:text-white transition-colors text-sm flex items-center gap-2" data-id="element-181">
                      <span className="w-1 h-1 bg-[#D4A843] rounded-full" data-id="element-182" />
                      {item.name}
                    </button>
                  </li>)}
              </ul>
            </div>

            {/* Legal */}
            <div data-id="element-183">
              <h3 className="text-lg font-serif font-bold mb-6 text-[#D4A843]" data-id="element-184">
                Information
              </h3>
              <ul className="space-y-3" data-id="element-185">
                <li data-id="element-186">
                  <button onClick={() => setActiveModal('privacy')} className="text-white/70 hover:text-white transition-colors text-sm flex items-center gap-2" data-id="element-187">
                    <span className="w-1 h-1 bg-[#D4A843] rounded-full" data-id="element-188" />
                    Privacy Policy
                  </button>
                </li>
                <li data-id="element-189">
                  <button onClick={() => setActiveModal('terms')} className="text-white/70 hover:text-white transition-colors text-sm flex items-center gap-2" data-id="element-190">
                    <span className="w-1 h-1 bg-[#D4A843] rounded-full" data-id="element-191" />
                    Terms of Use
                  </button>
                </li>
                {['Reports', 'Press', 'Careers'].map(item => <li key={item} data-id="element-192">
                    <a href="#" className="text-white/70 hover:text-white transition-colors text-sm flex items-center gap-2" data-id="element-193">
                      <span className="w-1 h-1 bg-[#D4A843] rounded-full" data-id="element-194" />
                      {item}
                    </a>
                  </li>)}
              </ul>
            </div>

            {/* Contact Info */}
            <div data-id="element-195">
              <h3 className="text-lg font-serif font-bold mb-6 text-[#D4A843]" data-id="element-196">
                Contact Information
              </h3>
              <ul className="space-y-4" data-id="element-197">
                <li className="flex items-start gap-3 text-white/70 text-sm" data-id="element-198">
                  <Mail size={18} className="text-[#D4A843] flex-shrink-0 mt-0.5" data-id="element-199" />
                  <span data-id="element-200">fgsukraine@gmail.com</span>
                </li>
                <li className="flex items-start gap-3 text-white/70 text-sm" data-id="element-201">
                  <Phone size={18} className="text-[#D4A843] flex-shrink-0 mt-0.5" data-id="element-202" />
                  <span data-id="element-203">+38 (067) 403 2026</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-white/50" data-id="element-204">
            <p data-id="element-205">© 2024 Fair Gaming Space. All rights reserved.</p>
            <p data-id="element-206">Built with love for fair gaming</p>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      {activeModal === 'privacy' && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={() => setActiveModal(null)} data-id="element-207">
          <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" data-id="element-208" />
          <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[85vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-209">
            <div className="sticky top-0 bg-white rounded-t-xl border-b border-gray-100 px-6 py-4 flex items-center justify-between z-10" data-id="element-210">
              <h3 className="text-xl font-serif font-bold text-[#0A5E5C]" data-id="element-211">
                Privacy Policy
              </h3>
              <button onClick={() => setActiveModal(null)} className="w-8 h-8 rounded-full flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors" data-id="element-212">
                <X className="w-5 h-5" data-id="element-213" />
              </button>
            </div>
            <div className="p-6 md:p-8 space-y-6 text-gray-700 leading-relaxed text-sm" data-id="element-214">
              <div className="text-center mb-4" data-id="element-215">
                <h4 className="text-lg font-serif font-bold text-[#0A5E5C]" data-id="element-216">
                  COMPREHENSIVE PRIVACY AND DATA PROTECTION POLICY
                </h4>
                <p className="text-[#D4A843] font-medium mt-1" data-id="element-217">
                  NGO "Fair Gaming Space"
                </p>
                <p className="text-gray-500 text-xs mt-1" data-id="element-218">
                  Revision: 18 February 2026
                </p>
              </div>

              <div className="space-y-5" data-id="element-219">
                <div data-id="element-220">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-221">
                    1. General Provisions
                  </h5>
                  <p data-id="element-222">
                    This Policy defines the procedure for processing and
                    protecting personal data by the NGO "Fair Gaming Space"
                    (FAIR Gaming Space). The organization acts in accordance
                    with the Law of Ukraine "On Personal Data Protection", and
                    also applies the principles of GDPR and UK GDPR when
                    interacting with residents of the EU or the UK.
                  </p>
                </div>
                <div data-id="element-223">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-224">
                    2. Data Processing Principles
                  </h5>
                  <p data-id="element-225">
                    Processing is carried out on the principles of lawfulness,
                    fairness, transparency, purpose limitation, data
                    minimization, accuracy, storage limitation, and ensuring
                    integrity and confidentiality.
                  </p>
                </div>
                <div data-id="element-226">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-227">
                    3. Categories of Data
                  </h5>
                  <p data-id="element-228">
                    Name, email, organization, IP address, technical data,
                    responses to research questionnaires, as well as anonymized
                    or pseudonymized data.
                  </p>
                </div>
                <div data-id="element-229">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-230">
                    4. Legal Basis (GDPR Art. 6, 9)
                  </h5>
                  <p data-id="element-231">
                    Consent of the data subject; legitimate interest;
                    fulfillment of statutory tasks; fulfillment of legal
                    obligations. Special categories of data are processed
                    exclusively on the basis of explicit consent and with
                    appropriate safeguards.
                  </p>
                </div>
                <div data-id="element-232">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-233">
                    5. International Data Transfer
                  </h5>
                  <p data-id="element-234">
                    In case of data transfer outside Ukraine or the EU, Standard
                    Contractual Clauses (SCC) or other legally provided
                    protection mechanisms are applied.
                  </p>
                </div>
                <div data-id="element-235">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-236">
                    6. Data Processing Agreement (DPA)
                  </h5>
                  <p data-id="element-237">
                    When engaging contractors (hosting, email services, CRM),
                    data processing agreements (DPA) are concluded that
                    establish the processor's obligations regarding security and
                    confidentiality.
                  </p>
                </div>
                <div data-id="element-238">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-239">
                    7. Cookies Policy
                  </h5>
                  <p data-id="element-240">
                    The site uses strictly necessary, analytical, and functional
                    cookies. The user can manage consent through the banner or
                    browser settings.
                  </p>
                </div>
                <div data-id="element-241">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-242">
                    8. Data Breach Response Procedure
                  </h5>
                  <p data-id="element-243">
                    In the event of a data security breach, the Organization
                    conducts an internal investigation, takes measures to
                    minimize risks, and notifies competent authorities and data
                    subjects within the time limits provided by law.
                  </p>
                </div>
                <div data-id="element-244">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-245">
                    9. Appointment of DPO
                  </h5>
                  <p data-id="element-246">
                    The Organization may appoint a Data Protection Officer (DPO)
                    who monitors compliance with legislation and accepts
                    requests from data subjects.
                  </p>
                </div>
                <div data-id="element-247">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-248">
                    10. Rights of Data Subjects
                  </h5>
                  <p data-id="element-249">
                    The right to access, rectification, erasure, restriction of
                    processing, data portability, withdrawal of consent, and
                    lodging a complaint with a supervisory authority.
                  </p>
                </div>
                <div data-id="element-250">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-251">
                    11. UK & US Compliance Block
                  </h5>
                  <p data-id="element-252">
                    In case of cooperation with UK or US grantors, the
                    Organization complies with the requirements of UK GDPR, UK
                    Data Protection Act, and also ensures compliance with
                    international data security standards and anti-corruption
                    legislation (UK Bribery Act, FCPA).
                  </p>
                </div>
                <div data-id="element-253">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-254">
                    12. Retention Periods
                  </h5>
                  <p data-id="element-255">
                    Data is stored no longer than necessary to achieve the
                    purpose of processing and fulfill legal or grant
                    requirements.
                  </p>
                </div>
                <div data-id="element-256">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-257">
                    13. Policy Updates
                  </h5>
                  <p data-id="element-258">
                    The current version of the Policy is always published on the
                    official website.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>}

      {/* Terms of Use Modal */}
      {activeModal === 'terms' && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={() => setActiveModal(null)} data-id="element-259">
          <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" data-id="element-260" />
          <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[85vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-261">
            <div className="sticky top-0 bg-white rounded-t-xl border-b border-gray-100 px-6 py-4 flex items-center justify-between z-10" data-id="element-262">
              <h3 className="text-xl font-serif font-bold text-[#0A5E5C]" data-id="element-263">
                Terms of Use
              </h3>
              <button onClick={() => setActiveModal(null)} className="w-8 h-8 rounded-full flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors" data-id="element-264">
                <X className="w-5 h-5" data-id="element-265" />
              </button>
            </div>
            <div className="p-6 md:p-8 space-y-6 text-gray-700 leading-relaxed text-sm" data-id="element-266">
              <div className="text-center mb-4" data-id="element-267">
                <h4 className="text-lg font-serif font-bold text-[#0A5E5C]" data-id="element-268">
                  TERMS OF USE
                </h4>
                <p className="text-[#D4A843] font-medium mt-1" data-id="element-269">
                  NGO "Fair Gaming Space" / FAIR Gaming Space
                </p>
                <p className="text-gray-500 text-xs mt-1" data-id="element-270">
                  Revision: 18 February 2026
                </p>
              </div>

              <div className="space-y-5" data-id="element-271">
                <div data-id="element-272">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-273">
                    1. General Provisions
                  </h5>
                  <p data-id="element-274">
                    These Extended Terms of Use govern the access and use of the
                    website of the Non-Governmental Organization "Fair Gaming
                    Space" (FAIR Gaming Space) (hereinafter — the Organization).
                    By using the Site, the User confirms full agreement with
                    these Terms. The Organization has the right to change the
                    Terms without prior notice.
                  </p>
                </div>
                <div data-id="element-275">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-276">
                    2. Independence and Non-affiliation
                  </h5>
                  <p data-id="element-277">
                    The Organization is an independent non-profit structure. It
                    does not carry out gambling activities, is not affiliated
                    with gambling operators, does not receive affiliate rewards,
                    and does not promote commercial services of operators.
                  </p>
                </div>
                <div data-id="element-278">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-279">
                    3. Research Integrity Clause
                  </h5>
                  <p data-id="element-280">
                    All research is conducted independently, in accordance with
                    the principles of academic integrity, methodological
                    transparency, and voluntary participation. Donors do not
                    influence the results of the research.
                  </p>
                </div>
                <div data-id="element-281">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-282">
                    4. Informational Nature of Materials
                  </h5>
                  <p data-id="element-283">
                    The materials on the Site are of an informational,
                    analytical, and educational nature. They do not constitute
                    legal, medical, or financial advice. The Organization is not
                    responsible for decisions made by the User based on the
                    materials of the Site.
                  </p>
                </div>
                <div data-id="element-284">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-285">
                    5. Registration and Participation in Research
                  </h5>
                  <p data-id="element-286">
                    The User can register to receive news or participate in
                    research. Participation in research is voluntary and based
                    on the principle of informed consent.
                  </p>
                </div>
                <div data-id="element-287">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-288">
                    6. Donations and Financial Transparency
                  </h5>
                  <p data-id="element-289">
                    Voluntary contributions are non-refundable charitable
                    assistance. The Organization ensures transparent financial
                    reporting and may undergo an independent audit.
                  </p>
                </div>
                <div data-id="element-290">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-291">
                    7. Anti-corruption and Sanctions Provisions
                  </h5>
                  <p data-id="element-292">
                    The Organization complies with the legislation of Ukraine,
                    international anti-corruption standards, UK Bribery Act, and
                    FCPA (in case of international funding). Funds from
                    sanctioned persons or structures are not accepted.
                  </p>
                </div>
                <div data-id="element-293">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-294">
                    8. Intellectual Property
                  </h5>
                  <p data-id="element-295">
                    All materials on the Site are protected by intellectual
                    property legislation. Commercial use without written
                    permission is prohibited.
                  </p>
                </div>
                <div data-id="element-296">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-297">
                    9. Personal Data Protection
                  </h5>
                  <p data-id="element-298">
                    The processing of personal data is carried out in accordance
                    with the Law of Ukraine "On Personal Data Protection" and
                    the principles of GDPR (in case of international
                    interaction).
                  </p>
                </div>
                <div data-id="element-299">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-300">
                    10. Limitation of Liability
                  </h5>
                  <p data-id="element-301">
                    The Organization does not guarantee the uninterrupted
                    operation of the Site and is not responsible for technical
                    interruptions or actions of third parties.
                  </p>
                </div>
                <div data-id="element-302">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-303">
                    11. Applicable Law
                  </h5>
                  <p data-id="element-304">The legislation of Ukraine applies to these Terms.</p>
                </div>
              </div>
            </div>
          </div>
        </div>}
    </>;
}